import { Action } from "../../types";
import { validateAPIPayloadType, validateAPIStateType } from "../../types/types";

const initialState = {
    apiResponses: {},
    token: "",
    validationStatus: {},
    APIState: {}
};

export function valiadteAPIReducer(
    state: validateAPIStateType = initialState,
    action: Action<validateAPIPayloadType>
): validateAPIStateType {
    switch (action.type) {
        case "setAPIResponse": {
            if (action.payload.data) {
                const id: string = action?.payload?.id ?? "";
                if (id !== "")
                    return {
                        ...state,
                        apiResponses: {
                            ...state.apiResponses,
                            [id]: action.payload.data,
                        }
                    }
                else return state
            } else return state;
        }

        case "setToken": {
            return {
                ...state,
                token: action?.payload?.token ?? "",
                apiResponses:{},
                APIState: {}
            }
        }

        case "setValidationStatus": {
            const id: string = action?.payload?.id ?? "";
            if (id !== "")
                return {
                    ...state,
                    validationStatus: {
                        ...state.validationStatus,
                        [id]: action.payload.data
                    }
                }
            else return state
        }

        case "setAPIState": {
            const apiId: string = action?.payload?.id ?? "";
            if (apiId !== "")
                return {
                    ...state,
                    APIState: {
                        ...state.APIState,
                        [apiId]: action.payload.data
                    }
                }
            else return state
        }

        case "resetToken": {
            return {
                ...state,
                token: ""
            }
        }
        case "resetAPIResponse":
            return { ...state, apiResponses: {} };

        case "resetValidationStatus":
            return { ...state, validationStatus: {} };

        case "resetAPIState":
            return { ...state, APIState: {} };
        
        case "resetAll": return {...initialState}
        

        default:
            return state;
    }
}
